require("!!/Users/makebetter/Documents/sportsceneDash/node_modules/script-loader/addScript.js")(require("!!/Users/makebetter/Documents/sportsceneDash/node_modules/raw-loader/index.js!/Users/makebetter/Documents/sportsceneDash/node_modules/bootstrap-notify/bootstrap-notify.js"))


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/script-loader!/Users/makebetter/Documents/sportsceneDash/~/bootstrap-notify/bootstrap-notify.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap-notify/bootstrap-notify.js
// module chunks = 2